module.exports = __webpack_public_path__ + "media/cyberpunk.774ecfd7.mp3";